/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber3 = createReactComponent("outline", "number-3", "IconNumber3", [["path", { "d": "M12 12a4 4 0 1 0 -4 -4", "key": "svg-0" }], ["path", { "d": "M8 16a4 4 0 1 0 4 -4", "key": "svg-1" }]]);

export { IconNumber3 as default };
//# sourceMappingURL=IconNumber3.mjs.map
